import { useCallback } from 'react';
import {
  CollectionState,
  FiltersMap,
  CollectionOptimisticActionsBaseParams,
  KeyedItem,
} from '@wix/bex-core';
import { useCreateOptimisticActions } from '@wix/bex-core/react';

export function useCreateNestedOptimisticActions() {
  const createOptimisticActions = useCreateOptimisticActions();

  return useCallback(
    <T, F extends FiltersMap>(
      collection: CollectionState<T, F>,
      state?: {
        readonly parent: KeyedItem<any> | null;
      },
      params?: Partial<CollectionOptimisticActionsBaseParams<T, F>>,
    ) =>
      createOptimisticActions(collection, {
        ...params,
        cacheNamespace: state?.parent?.id,
      }),
    [],
  );
}
